{
  "title": "AI Memory",
  "sidebarAriaLabel": "AI Memory sidebar content",
  "nav": {
    "memory": "Memory",
    "operations": "Operations",
    "overview": "Overview",
    "lessons": "Lessons",
    "evidence": "Evidence",
    "reviews": "Review queue",
    "notes": "Working notes",
    "sources": "Sources",
    "accounts": "Connector accounts",
    "health": "System health"
  },
  "pages": {
    "overview": {
      "title": "Overview",
      "description": "How memory turns collected evidence into lessons your agents reuse."
    },
    "lessons": {
      "title": "Lessons",
      "description": "What your team has learned, when it applies, and the evidence behind it."
    },
    "evidence": {
      "title": "Evidence",
      "description": "Everything your sources have collected, grouped by category. Open a record to see where it came from and where it is used."
    },
    "reviews": {
      "title": "Review queue",
      "description": "Check the evidence and decide which lessons are ready for reuse."
    },
    "notes": {
      "title": "Working notes",
      "description": "Private, unverified context for your own investigations."
    },
    "sources": {
      "title": "Sources",
      "description": "Review bounded collection, then keep evidence current."
    },
    "accounts": {
      "title": "Connector accounts",
      "description": "Provider accounts importers can choose when they set up a source. Credentials are write-only."
    },
    "health": {
      "title": "System health",
      "description": "Workers, queue, review backlog and the quality of what agents are learning."
    }
  },
  "session": {
    "loading": "Connecting to memory…",
    "errorTitle": "Memory is unavailable",
    "errorMessage": "The memory service could not be reached. Try again in a moment.",
    "requestId": "Request {{id}}",
    "noAccessTitle": "No access to {{page}}",
    "noAccessMessage": "Your memory session does not allow this view. Contact your administrator to request access.",
    "pinnedNotice": "This session reads a pinned memory revision. Changes are disabled."
  },
  "kinds": {
    "claim": "Lesson",
    "episode": "Investigation",
    "assertion": "Fact",
    "entity": "Entity",
    "evidence": "Evidence",
    "source_document": "Source document",
    "proposal": "Proposed lesson"
  },
  "kindsPlural": {
    "claim": "Lessons",
    "episode": "Investigations",
    "assertion": "Facts",
    "entity": "Entities",
    "evidence": "Evidence",
    "source_document": "Sources"
  },
  "kindCounts": {
    "claim": "{{count}} lesson",
    "claim_plural": "{{count}} lessons",
    "episode": "{{count}} investigation",
    "episode_plural": "{{count}} investigations",
    "assertion": "{{count}} fact",
    "assertion_plural": "{{count}} facts",
    "entity": "{{count}} entity",
    "entity_plural": "{{count}} entities",
    "evidence": "{{count}} evidence record",
    "evidence_plural": "{{count}} evidence records",
    "source_document": "{{count}} source",
    "source_document_plural": "{{count}} sources"
  },
  "status": {
    "active": "Active",
    "published": "Published",
    "supported": "Supported",
    "verified_recovered": "Verified recovered",
    "observed": "Observed",
    "needs_review": "Needs review",
    "needs_evidence": "Needs evidence",
    "deferred": "Deferred",
    "quarantined": "Quarantined",
    "retracted": "Retracted",
    "rejected": "Rejected",
    "stale": "Stale",
    "current": "Current",
    "hypothesis": "Hypothesis",
    "disputed": "Disputed",
    "superseded": "Superseded",
    "archived": "Archived"
  },
  "providers": {
    "github": "GitHub",
    "kubernetes": "Kubernetes",
    "datadog": "Datadog",
    "pagerduty": "PagerDuty",
    "aws": "AWS",
    "prometheus": "Prometheus",
    "grafana": "Grafana",
    "mezmo": "Mezmo",
    "repository": "Imported file",
    "incident_export": "Incident import",
    "lab": "Evaluation lab",
    "unknown": "Unknown source",
    "mock": "mock",
    "collectedFrom": "Collected from {{name}}",
    "collectedFromMock": "Collected from {{name}} (declared local mock)",
    "alsoFrom": "Also from {{names}}",
    "localMock": "Local mock source"
  },
  "common": {
    "notRecorded": "Not recorded",
    "none": "None recorded.",
    "service": "Service",
    "environment": "Environment",
    "allServices": "All services",
    "allEnvironments": "All environments",
    "search": "Search",
    "moreFilters": "More filters",
    "tryAgain": "Try again",
    "loading": "Loading…",
    "unavailableTitle": "Memories unavailable",
    "unavailableMessage": "Refresh when the memory service is reachable.",
    "proofOfConcept": "Proof of concept"
  },
  "evidenceKinds": {
    "runbook": "Runbook",
    "catalog": "Service catalog",
    "deployment_config": "Deployment config",
    "incident_export": "Incident",
    "postmortem": "Postmortem",
    "query_export": "Observation",
    "evidence": "Evidence",
    "source": "Source"
  }
}
